import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import type { ReactElement } from 'react';
import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { AppVersionApplicationFile } from '../../pages/applications-version-details-page/applicationVersionDetails.model';
import type { SystemPackageAppVersion } from '../../pages/create-system-package-version-page/createSystemPackageVersionPage.model';
import { DeviceAppVersionCard } from '../device-app-version-card/DeviceAppVersionCard.ctrl';
import { SystemPackageVersionDeploymentRulesField } from '../system-package-version-fields/SystemPackageVersionFields.ctrl';

export interface SystemPackageVersionDeploymentRulesStepProps {
  readonly control: Control<SystemPackageAppVersion>;
  readonly applicationFiles: AppVersionApplicationFile[];
  readonly triggerValidation?: () => void;
}

export function SystemPackageVersionDeploymentRulesStep({
  control,
  applicationFiles,
  triggerValidation,
}: SystemPackageVersionDeploymentRulesStepProps): ReactElement {
  const { t } = useTranslation(ALL_LNGS_NAMESPACES.APPLICATION);

  return (
    <DeviceAppVersionCard
      subtitle={t('subtitle.deploymentRulesSystemPackageSection')}
      title={t('title.deploymentRulesSection')}
    >
      <SystemPackageVersionDeploymentRulesField
        control={control}
        applicationFiles={applicationFiles}
        triggerValidation={triggerValidation}
      />
    </DeviceAppVersionCard>
  );
}
